module.exports = __webpack_public_path__ + "static/media/aluWindow.0dff678c.jpeg";